import { useTranslation } from "react-i18next";
import objetoService from "../axios/services/gastronomia";
import ObjetosScreen from "../components/Objetos/Objetos";
import { useNavigate } from 'react-router-dom';

export default function GastronomiasScreen() {
  const navigate = useNavigate();

  const target = "Gastronomia";
  const { t } = useTranslation();
  const title = t("common.gastronomias");
  return (
    <ObjetosScreen target={target} navigation={navigate} objetoService={objetoService} title={title} />
  );
}

